import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Briefcase } from "lucide-react";
import api from "../lib/api";
import PageHeader from "../components/PageHeader";
import { fmtEUR, initials } from "../lib/format";

export default function Clients() {
  const nav = useNavigate();
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/clients").then(({ data }) => setRows(data)); }, []);

  return (
    <div>
      <PageHeader title="Clienti Attivi" subtitle="Aziende convertite in cliente con progetti collegati" />
      {rows.length === 0 ? <div className="bg-white rounded-xl border border-slate-200 py-14 text-center text-slate-400"><Briefcase className="w-8 h-8 mx-auto mb-2 opacity-40" />Nessun cliente</div> : (
        <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-3">
          {rows.map((c) => (
            <button key={c.id} data-testid={`client-card-${c.id}`} onClick={() => nav(`/aziende/${c.id}`)} className="text-left bg-white rounded-xl border border-slate-200 p-5 hover:shadow-md transition-shadow">
              <div className="flex items-center gap-3">
                <div className="w-11 h-11 rounded-xl bg-emerald-50 text-emerald-700 flex items-center justify-center font-heading font-bold">{initials(c.legal_name)}</div>
                <div><p className="font-heading font-semibold text-slate-800">{c.legal_name}</p><p className="text-xs text-slate-400">{c.sector} · {c.country}</p></div>
              </div>
              <div className="mt-4 pt-3 border-t border-slate-100">
                <p className="text-xs text-slate-400 mb-1.5">{c.projects.length} progetto/i</p>
                {c.projects.slice(0, 3).map((p) => <div key={p.id} className="flex justify-between text-sm py-0.5"><span className="text-slate-600 truncate">{p.name}</span><span className="font-mono text-slate-500">{fmtEUR(p.value)}</span></div>)}
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
